import React, { useEffect } from 'react'
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { currencyOptionsMap, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import { AppCurrencyAutocomplete } from "@components"

export default function UserCurrencyField() {

	const { defaultCurrency, setDefaultCurrencyInfo } = useAdminUsersInfo(userPayload.peek()?.user?.defaultCurrency, "defaultCurrency", "user")

	const { errors, isValid } = useValidatorSeeker(
		{ defaultCurrency: defaultCurrency },
		object({
			defaultCurrency: string().required('Must provide a Currency')
		})
	)

	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), defaultCurrency: isValid }
	}, [isValid])

	return <AppCurrencyAutocomplete
		value={defaultCurrency}
		onFinishAjax={options => {
			currencyOptionsMap.value = { ...currencyOptionsMap.value, ...Object.fromEntries(options.map(o => [String(o.value), o.label])) }
		}}
		onChange={e => setDefaultCurrencyInfo(e.target.value)}
		error={errors?.defaultCurrency}
	/>
}